
<div class="flex-panel" :style="'height:' + height + 'px'">
    <div v-for="(item,index) in items" :key="index" style="margin-left: 2px;">
        <c-tag
            :width            = "width"
            :label            = "item.responsibility.name"
            :active           = "item.selected"
            :background-color = "backgroundColor"
            class             = "tag"
        />
    </div>
</div>
